<template>
    <div class="m-table-container">
        <Table ref="editTable" v-bind='$attrs' :size="size" highlight-row :height="height" class="edit-table" :columns="columns" :loading="loading" :data="value" :thDrag="thDrag" border @on-row-dblclick="handleRowDblClick" @on-selection-change="handleSelectionChange" @on-sort-change="handleSortChange">
            <div slot="header" v-if="showHeader" class="edit-table-header-btn">
            <slot name="header"></slot>
            </div>
            <div slot="footer" v-if="showFooter">
            <slot name="footer"></slot>
            </div>
        </Table>
    </div>
</template>

<script>
import {componentType} from './config';
import scrollBar from '@/utils/table-scroll-bar.js';
import sticky from '@/utils/sticky.js';
/**
 * 修复选中项选中状态
 * @param vm 当前vue实例
 */
const fixSelection = (vm) => {
  for (let i = 0; i < vm.value.length; i++) {
    vm.value[i]._checked = false;
    vm.selection.forEach(item => {
      if (typeof vm.value[i][vm.uniqueKey] === 'object' && vm.value[i][vm.uniqueKey] !== null) {
        if (vm.value[i][vm.uniqueKey].value === item[vm.uniqueKey]) {
          vm.value[i]._checked = true;
        }
      } else {
        if (vm.value[i][vm.uniqueKey] === item[vm.uniqueKey]) {
          vm.value[i]._checked = true;
        }
      }
    });
  }
};
const cellInput = (h, vm, params, col) => {
  return h('Input', {
    props:
      {
        value: params.row[col.key].value,
          type: col.type ? col.type : 'text'
      },
    on: {
       'on-blur' (event) {
         vm.value[params.index][col.key].value = event.target.value;
         for (let i = 0; i < vm.selection.length; i++) {
           if (params.row[vm.uniqueKey].value === vm.selection[i][vm.uniqueKey]) {
             vm.selection[i][col.key] = event.target.value;
           }
         }
         fixSelection(vm);
         vm.$emit('on-cell-input-blur', params.row, params.index, col);
      },
      'on-input' (event) {
         vm.value[params.index][col.key].value = event.target.value;
         for (let i = 0; i < vm.selection.length; i++) {
           if (params.row[vm.uniqueKey].value === vm.selection[i][vm.uniqueKey]) {
             vm.selection[i][col.key] = event.target.value;
           }
         }
         fixSelection(vm);
         vm.$emit('on-cell-input-input', params.row, params.index, col);
      }
    }
  });
}; // 单元格内的文本框控件
const cellDatePicker = (h, vm, params, col) => {
  return h('DatePicker', {
    props: {
      value: params.row[col.key].value,
      type: col.type ? col.type : 'date',
      format: col.format ? col.format : 'yyyy-MM-dd',
      placement: col.placement ? col.placement : 'top',
      options: col.options
    },
    on: {
      'on-change' (date) {
        vm.value[params.index][col.key].value = date;
        for (let i = 0; i < vm.selection.length; i++) {
          if (params.row[vm.uniqueKey].value === vm.selection[i][vm.uniqueKey]) {
            vm.selection[i][col.key] = date;
          }
        }
        fixSelection(vm);
      }
    }
  });
}; // 单元格内的日期选择器控件
const cellCheckbox = (h, vm, params, col) => {
  return h('Checkbox', {
    props: {
      value: params.row[col.key].value,
        trueValue: col.trueValue ? col.trueValue : true,
        falseValue: col.falseValue ? col.falseValue : false
    },
    on: {
      'on-change' (checked) {
        vm.value[params.index][col.key].value = checked;
        for (let i = 0; i < vm.selection.length; i++) {
          if (params.row[vm.uniqueKey].value === vm.selection[i][vm.uniqueKey]) {
            vm.selection[i][col.key] = checked;
          }
        }
        fixSelection(vm);
      }
    }
  }, params.row[col.key].label);
}; // 单元格内的多选框控件
const cellCheckboxGroup = (h, vm, params, col) => {
  let checkboxOptions = [];
  if (col.options) {
    col.options.forEach(opt => {
      checkboxOptions.push(h('Checkbox', {props: {label: opt}}));
    });
  }
  return h('CheckboxGroup', {
    props: {
      value: params.row[col.key].value
    },
    on: {
      'on-change' (selection) {
        vm.value[params.index][col.key].value = selection;
        for (let i = 0; i < vm.selection.length; i++) {
          if (params.row[vm.uniqueKey].value === vm.selection[i][vm.uniqueKey]) {
            vm.selection[i][col.key] = selection;
          }
        }
        fixSelection(vm);
      }
    }
  }, checkboxOptions);
}; // 单元格内的多选框组控件
const cellRadio = (h, vm, params, col) => {
  return h('Radio', {
    props: {
      value: params.row[col.key].value,
      disabled: col.disabled
    },
    on: {
      'on-change' (checked) {
        vm.value[params.index][col.key].value = checked;
        for (let i = 0; i < vm.selection.length; i++) {
          if (params.row[vm.uniqueKey].value === vm.selection[i][vm.uniqueKey]) {
            vm.selection[i][col.key] = checked;
          }
        }
        fixSelection(vm);
      }
    }
  }, col.option);
}; // 单元格内的单选框控件
const cellRadioGroup = (h, vm, params, col) => {
  let radioOptions = [];
  if (col.options) {
    col.options.forEach(opt => {
      radioOptions.push(h('Radio', {props: {label: opt.value}}, opt.label));
    });
  }
  return h('RadioGroup', {
    props: {
      value: params.row[col.key].value
    },
    on: {
      'on-change' (selection) {
        vm.value[params.index][col.key].value = selection;
        for (let i = 0; i < vm.selection.length; i++) {
          if (params.row[vm.uniqueKey].value === vm.selection[i][vm.uniqueKey]) {
            vm.selection[i][col.key] = selection;
          }
        }
        fixSelection(vm);
        vm.$emit('on-cell-radio-group-change', params.row, col, selection);
      }
    }
  }, radioOptions);
}; // 单元格内的单选框组控件
const cellSelect = (h, vm, params, col) => {
  let selectOptions = [];
  if (col.options) {
    col.options.forEach(opt => {
      selectOptions.push(h('Option', {props: {value: opt.value, disabled: opt.disabled}}, opt.label));
    });
  }
  return h('Select', {
    props: {
      value: params.row[col.key].value,
      clearable: col.clearable ? true : col.clearable,
      placement: col.placement ? col.placement : 'top'
    },
    on: {
      'on-change' (selection) {
        vm.value[params.index][col.key].value = selection;
        for (let i = 0; i < vm.selection.length; i++) {
          if (params.row[vm.uniqueKey].value === vm.selection[i][vm.uniqueKey]) {
            vm.selection[i][col.key] = selection;
          }
        }
        fixSelection(vm);
        vm.$emit('on-cell-select-change', params.row, params.index, col, selection);
      }
    }
  }, selectOptions);
}; // 单元格内的下拉框控件
const cellMagnifier = (h, vm, params, col) => {
  return h('Input', {
    props: {
      icon: 'search',
      value: params.row[col.key].value
    },
    on: {
      'on-click' () {
        vm.$emit('on-cell-magnifier', params.row, params.index, col);
      },
      'on-blur' (event) {
        vm.value[params.index][col.key].value = event.target.value;
        for (let i = 0; i < vm.selection.length; i++) {
          for (let prop in vm.selection[i]) {
            if (prop === col.key) {
              vm.selection[i][col.key] = event.target.value;
            }
          }
        }
        fixSelection(vm);
        vm.$emit('on-magnifier-blur', params.row, params.index, col);
      },
      'on-change' (event) {
        vm.value[params.index][col.key].value = event.target.value;
        params.row[col.key].value = event.target.value;
        for (let i = 0; i < vm.selection.length; i++) {
          for (let prop in vm.selection[i]) {
            if (prop === col.key) {
              vm.selection[i][col.key] = event.target.value;
            }
          }
        }
        fixSelection(vm);
        vm.$emit('on-magnifier-change', params.row, params.index, col);
      }
    }
  });
}; // 单元格内的放大镜组件（只提供放大镜图标及其点击事件，需要自己在点击事件里实现放大镜功能）
const editButton = (h, currentRow, vm, index) => {
  let isEditing = vm.isRowEditing(currentRow);
  let button = h('Button', {
    props: {
      type: 'text',
      size: 'large',
      icon: isEditing ? 'checkmark' : 'edit'
    },
    style: {
      display: isEditing ? 'none' : ''
    },
    on: {
      'click' () {
        vm.changeRowState(index, !isEditing);
        if (!isEditing) {
          vm.$emit('on-row-edit', currentRow, index);
        }
      }
    }
  });
  return h('Tooltip', {props: {content: isEditing ? vm.$t('page.editTable.tSave') : vm.$t('page.editTable.tEdit'), placement: 'top'}}, [button]);
}; // 操作列编辑按钮
const viewButton = (h, currentRow, vm, index) => {
  let button = h('Button', {
    props: {
      type: 'text',
      size: 'large',
      icon: 'eye'
    },
    on: {
      'click' () {
        vm.$emit('on-row-view', currentRow, index);
      }
    }
  });
  return h('Tooltip', {props: {content: vm.$t('page.editTable.tView'), placement: 'top'}}, [button]);
}; // 操作列查看按钮
const deleteButton = (h, currentRow, vm, index) => {
  let button = h('Poptip', {
    props: {
      confirm: true,
      title: vm.$t('page.editTable.confirmDelete'),
      transfer: true
    },
    on: {
      'on-ok' () {
        vm.value.splice(index, 1);
        vm.$emit('on-row-delete-success', vm.value, currentRow);
      }
    }
  }, [
    h('Button', {
      props: {
        type: 'text',
        placement: 'top',
        icon: 'android-delete',
        size: 'large'
      }
    })
  ]);
  return h('Tooltip', {props: {content: vm.$t('page.editTable.tDelete'), placement: 'top'}}, [button]);
}; // 操作列删除按钮
const customButton = (h, currentRow, vm, index, btn) => {
  let button = h('Button', {
    props: {
      type: 'text',
      size: 'large',
      icon: btn.icon
    },
    on: {
      'click' () {
        vm.$emit(btn.event, currentRow, index);
      }
    }
  });
  return h('Tooltip', {props: {content: btn.title, placement: 'top'}}, [button]);
}; // 操作列自定义按钮
export default {
  name: 'EditTable',
  mixins: [scrollBar, sticky],
  data () {
    return {
        parent: 'm-table-container',
        tableRefName: 'editTable',
      data: [],
      selection: []
    };
  },
  props: {
    size: {
      type: String,
      default: 'small'
    },
    uniqueKey: {
      type: String,
      default: ''
    },
    columns: {
      type: Array,
      default () {
        return [];
      }
    },
    value: {
      type: Array,
      default () {
        return [];
      }
    },
    editingAll: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: false
    },
    height: {
        type: String,
        default: 'auto'
    },
    thDrag: {
      type: Boolean,
      default: false
    },
    isRowDbClickEnabled: {
        type: Boolean,
        default: true
    },
    loading: {
      type: Boolean,
      default: false
    }, // 是否显示正在加载
        needScrollBar: {
            type: Boolean,
            default: false,
        },
        needSticky: {
            type: Boolean,
            default: false,
        },
  },
  created () {
    this.renderTable(this);
  },
  methods: {
    /**
     * 渲染表格
     **/
    renderTable (vm) {
      console.log('执行了renderTable方法');
      vm.columns.forEach(col => {
        if (col.type !== 'selection' && col.type !== 'opr' && col.type !== 'index') {
          if (!col.render) {
            col.render = (h, param) => {
              let currentRow = vm.value[param.index];
              switch (col.editType) {
                case componentType.Input:
                  if (currentRow[col.key].editable && currentRow[col.key].editing) {
                    return cellInput(h, vm, param, col, currentRow[col.key].value);
                  } else {
                    if (col.showTips) {
                      return h('Tooltip', {
                          props: {
                              content: currentRow[col.key].value,
                              placement: 'top'
                          },
                          class: 'm-tooltip-overflow'
                      }, currentRow[col.key].value);
                    } else {
                      return h('span', currentRow[col.key].value);
                    }
                  }
                case componentType.DatePicker:
                  if (currentRow[col.key].editable && currentRow[col.key].editing) {
                    return cellDatePicker(h, vm, param, col);
                  } else {
                    return h('span', {style: {'wordBreak': 'break-word'}}, currentRow[col.key].value);
                  }
                case componentType.Radio:
                  if (currentRow[col.key].editable && currentRow[col.key].editing) {
                    return cellRadio(h, vm, param, col);
                  } else {
                    if (currentRow[col.key].value === true) {
                      return h('Icon', {props: {type: 'checkmark'}});
                    } else {
                      return h('');
                    }
                  }
                case componentType.RadioGroup:
                  if (currentRow[col.key].editable && currentRow[col.key].editing) {
                    return cellRadioGroup(h, vm, param, col);
                  } else {
                    let label = '';
                    col.options.forEach(item => {
                      if (item.value === currentRow[col.key].value) {
                        label = item.label;
                      }
                    });
                    return h('span', label);
                  }
                case componentType.Checkbox:
                  if (currentRow[col.key].editable && currentRow[col.key].editing) {
                    return cellCheckbox(h, vm, param, col);
                  } else {
                    if (currentRow[col.key].value === true) {
                      return h('Icon', {props: {type: 'checkmark'}});
                    } else {
                      if (col.showIcon) {
                        return h('Icon', {props: {type: 'close'}});
                      } else {
                        return h();
                      }
                    }
                  }
                case componentType.CheckboxGroup:
                  if (currentRow[col.key].editable && currentRow[col.key].editing) {
                    return cellCheckboxGroup(h, vm, param, col);
                  } else {
                    return h('span', currentRow[col.key].value.join(','));
                  }
                case componentType.Select:
                  if (currentRow[col.key].editable && currentRow[col.key].editing) {
                    return cellSelect(h, vm, param, col);
                  } else {
                    let label = '';
                    if (col.options) {
                      col.options.forEach(opt => {
                        if (opt.value === currentRow[col.key].value) {
                          label = opt.label;
                        }
                      });
                    } else {
                      label = currentRow[col.key].value;
                    }
                    return h('span', label);
                  }
                case componentType.Magnifier:
                  if (currentRow[col.key].editable && currentRow[col.key].editing) {
                    return cellMagnifier(h, vm, param, col);
                  } else {
                    return h('span', currentRow[col.key].value);
                  }
                case undefined:
                default:
                  return h('span', col.key && currentRow[col.key] ? currentRow[col.key].value : '');
              }
            };
          }
        } else if (col.type === 'opr' && col.handle) {
          if (!col.render) {
            col.render = (h, param) => {
              let currentRow = vm.value[param.index];
              let buttons = [];
              if (col.handle.system) {
                col.handle.system.forEach(btn => {
                  if (btn === 'edit') {
                    buttons.push(editButton(h, currentRow, vm, param.index));
                  } else if (btn === 'view') {
                    buttons.push(viewButton(h, currentRow, vm, param.index));
                  } else if (btn === 'delete') {
                    buttons.push(deleteButton(h, currentRow, vm, param.index));
                  }
                });
              }
              if (col.handle.custom) {
                col.handle.custom.forEach(btn => {
                  buttons.push(customButton(h, currentRow, vm, param.index, btn));
                });
              }
              return h('div', buttons);
            };
          }
        }
      });
    },
    /* ****************** 方法 start****************** */
    /**
     * 改变一行的可编辑状态
     * param @index
     * param @editing
     **/
    changeRowState (index, editing) {
      console.log('执行了changeRowState方法');
      this.columns.forEach(col => {
        if (col.type !== 'selection' && col.type !== 'opr' && col.type !== 'index') {
          if (col.key) {
            this.value[index][col.key].editing = editing;
          }
        } else if (col.type === 'selection' && this.uniqueKey !== '') {
          fixSelection(this);
        }
      });
    },
    /**
     *  改变整个表格的可编辑状态
     * @param editing
     */
    changeTableState (editing) {
      console.log('执行了changeTableState方法');
      this.columns.forEach(col => {
        if (col.type !== 'selection' && col.type !== 'opr' && col.type !== 'index') {
          for (let i = 0; i < this.value.length; i++) {
            if (col.key) {
              this.value[i][col.key].editing = editing;
            }
          }
        } else if (col.type === 'selection' && this.uniqueKey !== '') {
          fixSelection(this);
        }
      });
    },
    /**
     * 判断当前行是否处于可编辑状态
     * @param currentRow
     */
    isRowEditing (currentRow) {
      console.log('执行了isRowEditing方法');
      let isEditing = false;
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].type !== 'selection' && this.columns[i].type !== 'opr' && this.columns[i].type !== 'index') {
          if (this.columns[i].key && currentRow[this.columns[i].key] && currentRow[this.columns[i].key].editing) {
            isEditing = true;
            break;
          }
        }
      }
      return isEditing;
    },
    /* ****************** 方法 end****************** */
    /* ****************** 事件 start****************** */
    /**
     * 表格行双击时触发
     * @param row
     * @param index
     */
    handleRowDblClick (row, index) {
      console.log('执行了handleRowDblClick方法');
      if (!this.isRowDbClickEnabled) {
            return;
      }
      this.changeRowState(index, !this.isRowEditing(row));
    },
    /**
     * 选中项发生变化时触发
     * @param selection
     */
    handleSelectionChange (selection) {
      console.log('执行了handleSelectionChange方法');
      this.selection = [];
      selection.forEach(item => {
        let row = {};
        for (let key in item) {
          if (key !== 'selection') {
            if (typeof item[key] === 'object' && item[key] !== null) {
              if (item[key].value) {
                row[key] = item[key].value;
              }
            } else {
              row[key] = item[key];
            }
          }
        }
        this.selection.push(row);
      });
      this.$emit('on-selection-change', this.selection);
    },
    handleSortChange (column, key, order) {
      this.$emit('on-sort-change', column, key, order);
    }
    /* ****************** 事件 end****************** */
  },
  watch: {
    editingAll(val) {
      this.changeTableState(val);
    }
  }
};
</script>

<style lang="less">
  .edit-table {
    .edit-table-header-btn {
      button {
        float: left;
        margin-left: 8px;
        margin-top: 8px;
      }
    }
    .edit-table-header-btn:after{
      clear: both;
      content: '';
      display: block;
    }
    .m-tooltip {
      .m-tooltip-rel {
        .m-btn-large {
          padding: 6px;
        }
      }
    }
    .m-table-fixed, .m-table-fixed-right {
      top: 48px;
    }
  }
</style>
